module.exports = __webpack_public_path__ + "img/true_icon.039d1246.svg";